<template>
  <div class="form-iframe-container" :style="{ height: iframeHeight }">
    <iframe class="form-iframe" frameborder="0" scrolling="no" :src="source" title="petition"></iframe>
  </div>
</template> 

<script>
export default {
  name: "enIframe",
  props: {
    source: {
      type: String,
      default: ""
    },
    goto: {
      type: String
    }
  },
  data() {
    return {
      iframeHeight: "500px",
      origin: ""
    };
  },
  methods: {
    receiveMessage(event) {
      if (event.origin !== this.origin) return;
      if (event.data.type == "form-submitted") {
        this.$store.commit("updateForm", {
          id: "firstName",
          value: event.data.firstName
        });
        this.$store.commit("updateForm", {
          id: "email",
          value: event.data.email
        });
        this.$store.commit("updateForm", {
          id: "optin",
          value: event.data.optin
        });

        this.analytics("petition", "submitted");
        this.analytics("optin", event.data.optin.toString());
        console.log("success!");
        console.log(this.$store.state.form);

        this.gotoSlide(this.goto);
        if (window.fbq) {
          window.fbq("trackCustom", "petitionSigned");
          if (event.data.optin) {
            window.fbq("trackCustom", "optedIn");
          }
        }

        this.$store.commit("updateExtraProgress");
      }
      if (event.data.type === "resize") {
        this.iframeHeight = event.data.height;
      }
    }
  },
  mounted() {
    window.addEventListener("message", this.receiveMessage, false);
    const srcSplit = this.source.split("/");
    this.origin = srcSplit[0] + "//" + srcSplit[2];
  }, 
  updated() {
    const srcSplit = this.source.split("/");
    this.origin = srcSplit[0] + "//" + srcSplit[2];
  }
};
</script>
<style lang="scss" scoped>
.form-iframe-container {
  width: 100%;
  height: 450px;
  position: relative;
  padding-bottom: 56.25%;
  display: block;
  width: 100%;
  @media only screen and (min-width: 1200px) {
    padding-bottom: 48%;
  }
  @media only screen and (max-width: 991px) {
    height: 530px;
  }
  @media only screen and (max-width: 767px) {
    height: 950px;
  }
  @media only screen and (max-width: 330px) {
    height: 1030px;
  }
  .form-iframe {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    overflow:hidden;
  }
}
</style>